import React, { useEffect, useState } from 'react';
import { Tabs, Card, Radio, Typography, Tag } from 'antd';

const { Title, Text } = Typography;

interface MCQItem {
    _id: string;
    section: {
        _id: string;
        name: string;
    };
    mcqQuestion: {
        question: string;
        options: {
            _id: string;
            option: string;
        }[];
        correctAnswer: string;
    };
    selectedOptions: string;
}

const MCQTabs = ({ mcqData }) => {
    const [mcqs, setMcqs] = useState<MCQItem[]>([]);

    useEffect(() => {
        if (mcqData) {
            setMcqs(mcqData);
        }
    }, [mcqData]);

    // Group questions by section
    const sections = mcqs.reduce((acc: any, item) => {
        const sectionName = item.section.name;
        if (!acc[sectionName]) acc[sectionName] = [];
        acc[sectionName].push(item);
        return acc;
    }, {});

    const getOptionStyle = (option: string, selected: string, correct: string) => {
        if (option === correct) return { color: 'green', fontWeight: 'bold' };
        if (option === selected && option !== correct) return { color: 'red', fontWeight: 'bold' };
        return {};
    };

    return (
        <>
            <Tabs>
                {Object.entries(sections).map(([sectionName, questions]: any) => (
                    <Tabs.TabPane tab={sectionName} key={sectionName}>
                        {questions.map((item: MCQItem, index: number) => {
                            const { question, options, correctAnswer } = item.mcqQuestion;
                            const selected = item.selectedOptions;

                            return (
                                <Card key={item._id} style={{ marginBottom: 16 }}>
                                    <Title level={5}>{index + 1}. {question}</Title>

                                    <Radio.Group value={selected}>
                                        {options.map((opt) => (
                                            <Radio
                                                key={opt._id}
                                                value={opt.option}
                                                style={getOptionStyle(opt.option, selected, correctAnswer)}
                                                disabled
                                            >
                                                {opt.option}
                                            </Radio>
                                        ))}
                                    </Radio.Group>

                                    <div style={{ marginTop: 8 }}>
                                        {selected === correctAnswer ? (
                                            <Tag bordered={false} color="green">Correct</Tag>
                                        ) : (
                                            <>
                                                {!selected && <Tag bordered={false} color="orange">Not Attempted</Tag>}
                                                {selected && <Tag bordered={false} color="red">Wrong</Tag>}
                                            </>
                                        )}
                                    </div>
                                </Card>
                            );
                        })}
                    </Tabs.TabPane>
                ))}
            </Tabs>
        </>
    );
};

export default MCQTabs;
